import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {displayTimeTrackingButtons } from 'dashboard/processing/PostingSharedMethods';
import ContractorTransactionsPage from 'dashboard/userData/contractorTransactions/ContractorTransactionsPage';
import {
    makeRequest,
    dispatchAction,getCurrentStoreState,
    displayMessage
} from 'actions';
import {
    Row,
    Col,
    Tabs,
    Tab,
    Form,
    FormGroup,
    Checkbox,
    Modal,
    ControlLabel,
    FormControl,
    Button
} from 'react-bootstrap';
import Select   from 'react-select'
import {
    FETCH_ADMIN_USER_TIME_TRACKING,
    CLEAR_SELECTED_USER_TIME_TRACKING,UPDATE_CUSTOM_USER_DATA,
    ADD_SELECTED_USER_TIME_TRACKING,
} from "actions/actionTypes";
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList, convertToHoursAndMinutes} from 'util/Utils';
import AdminUserTimeTrackingTable from 'dashboard/userData/AdminUserTimeTrackingTable';
import AdminUserTimeTrackingSearchBox from 'dashboard/userData/AdminUserTimeTrackingSearchBox'
import AdminUserTimeTrackingActionsBox from 'dashboard/userData/AdminUserTimeTrackingActionsBox'
import {checkValidDates,startTimeTrackingInterval, fetchAllContractorsList,fetchCurrentContractorRecord}  from 'shared/sharedMethods';
import moment   from 'moment'
import Datetime from 'react-datetime'

import RemoveModalDialog from'shared/RemoveModalDialog';
import config from  '../../../config';
import json2csv from "json2csv";



class AdminUserTimeTrackingPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }


    constructor(props, context) {
        super(props, context);
        var defaultTab = this.props.location.pathname.substring(this.props.location.pathname.lastIndexOf('/admin') + 6)


        this.state = {
            pending: false,
             totalDuration: 0,
            TimeTrackingStartTime: '',
            TimeTrackingEndTime: '',
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            showModal: false,
            selectAllRecords: false,
            defaultTab: defaultTab,
            contractorsOptionsList: []
        };
        this.searchBox = false;

     };

    componentDidMount() {
        fetchCurrentContractorRecord.call(this)

        if (this.state.defaultTab == '/time-tracking') {

            var queryParams = queryString.parse(this.props.location.search);

            var params = {
                'page': _.isUndefined(queryParams.page) || parseInt(queryParams.page) <= 1 ? 1 : parseInt(queryParams.page),
                perPage: _.isUndefined(queryParams.perPage) ? config.table.numberPerPage : parseInt(queryParams.perPage),
                doNotUpdateUrlString: true,
            }
            if (!_.isUndefined(queryParams.sortBy)) {
                params.sortBy = queryParams.sortBy
            }

            if (!_.isUndefined(queryParams.searchText)) {
                params.searchText = queryParams.searchText
            }
            this.search(params)
        }
        if ( _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom'])) ==0 ) {
            fetchAllContractorsList.call(this)
            this.setState({
                contractorsOptionsList: prepareSelectOptionsList(_.filter(this.props.allContractorsList.data, {Status: 'Active'}), {
                    label: 'UserFullName',
                    value: '_id'
                })
            })

        }


        if (_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false)) {
            startTimeTrackingInterval.call(this,_.get(this.props.userReducer, ['customUserData']))

        }
        // this.eventSource.addEventListener('flightStateUpdate', (e) =>{
        //     console.log('flightStateUpdate', JSON.parse(e.data)  );
        //
        // });
        //
        // this.eventSource.addEventListener('closedConnection', () => {
        //    console.log('closed connection event'   );
        // });
    }

    componentWillReceiveProps(nextProps) {

        if (_.size(nextProps.allContractorsList.data) !== _.size(this.props.allContractorsList.data)) {
            console.log('contractors receive', _.filter(nextProps.allContractorsList.data, {Contractor: true}));
            this.setState({
                contractorsOptionsList: prepareSelectOptionsList(_.filter(nextProps.allContractorsList.data, {Status:'Active'}) , {
                    label: 'UserFullName',
                    value: '_id'
                })
            })


        }

        if (_.get(nextProps.userReducer, ['customUserData', 'timeTrackingStarted'], false) && !_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false)) {/* time tracking started */
            startTimeTrackingInterval.call(this,_.get(nextProps.userReducer, ['customUserData'], {}))
        } else if (_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false) && !_.get(nextProps.userReducer, ['customUserData', 'timeTrackingStarted'], false)) {/* time tracking stopped */
            clearInterval(this.intervalID);
        }
    }
    componentWillUnmount() {

        clearInterval(this.intervalID);

    }






    editRecord(row) {
        console.log('row', row);

        this.setState({
            showModal: true,
            ActivityType: _.find(config.timeTrackingActivityData, item=>{
                return item.name ==   _.get(row, 'ActivityType', '')
            }),
            TimeTrackingStartTime: moment(row.StartTime),
            TimeTrackingEndTime: moment(row.EndTime),
            Comment: _.get(row, 'Comment', ''),
            newDuration: convertToHoursAndMinutes(moment.duration(row.Duration), {format: 'minutes_in_percentage'}),
            newDuratonInHoursAndMinutes: moment.utc(row.Duration).format("HH:mm"),
            currentRecord: {
                ...row,
            },

        }, function () {

        });
    }

    onDateChange(option, field) {
        var d = moment(option, 'D/M/YYYY');

        if (d == null || !d.isValid()) {
            return false;
        }
         if(field == 'TimeTrackingEndTime'){
            option.set({'second':0,millisecond:0})
         }else{
            option.set({'second':0,millisecond:0})
        }
        this.setState({
            [field]: option
        }, function () {

        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},

        });
    }




    onSortChange(field, sortOrder) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
        if (_.isUndefined(params.doNotClearSelectedRecords) && _.isUndefined(params.page)) { /* do not clear selected transactions when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_USER_TIME_TRACKING)
        }
        if (!this.searchBox) {
            return
            /* when called from componentWillMount in AdminUserTimeTrackingSearchBox on initial load*/
        }
        var {queryParams} = this.searchBox.getSearchParams();
        _.extend(queryParams, params);

        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
            queryParams.sortBySecondary = '_id:-1';
            /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
        }
        //queryParams.lookup = ['ProductsAdded']
        //    queryParams.Types =  ['WorkingTime']
        queryParams.lookup = ['ContractorID', 'UserID']

        var methodData = {
            "endpoint": "/users_data",
            'not_display_success_message': true,
        };

        if (_.isUndefined(params.include)) {
            methodData['success_event'] = FETCH_ADMIN_USER_TIME_TRACKING;
        }
        if (_.isUndefined(params.doNotUpdateUrlString)) {
            const stringified = queryString.stringify(_.omit(queryParams, ['include','Statuses', 'lookup', 'all', 'sortBySecondary']));
            this.context.router.push('/admin/time-tracking?' + stringified);
        }
        return this.props.makeRequest(queryParams, methodData).then(res => {
            this.setState({pending:false})
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                this.refs.pagination.resetPagination();
            }
            // var itemIDs = _.map(_.get(res.data,'data',[]), function ( item) {
            //     return  item._id
            // }, 0)

            if (_.isUndefined(params.include)) {
                var TotalTimeLogsDuration = _.reduce(_.get(res.data, 'data', []), function (total, item) {
                    total += item.Duration
                    return total
                }, 0)

                var timeLogsTotalTime = moment.duration(TotalTimeLogsDuration);

                var totalDuration = convertToHoursAndMinutes(timeLogsTotalTime, {format: 'hours_and_minutes'})

                this.setState({
                    totalDuration: totalDuration
                })
            }
            return res;
        }).catch(err => {
            this.setState({pending:false})
        });
    }

    onSelectAllRecordsChange() {
        if (!this.state.selectAllRecords) {

            this.search({include: ['_id'], all: true}).then(response => {
                this.setState({selectAllRecords: true});
                this.props.dispatchAction(response.data.data, ADD_SELECTED_USER_TIME_TRACKING)
            });
        } else {
            this.setState({selectAllRecords: false});
            this.props.dispatchAction({}, CLEAR_SELECTED_USER_TIME_TRACKING)
        }
    }

    saveRecord() {
        var self = this;
        this.setState({pending: true});
        var formData = this.validateAndGetFormData();
        if (!formData) {
            this.setState({pending: false});
            return false;
        }
        var methodData = {
            "endpoint": "/users_data" + '/' + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
        };
        self.props.makeRequest(formData, methodData).then(pickupUpdateResponse => {
            self.setState({pending: false});

            self.search({page:self.state.currentPage+1})
            self.closeModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }

    validateAndGetFormData() {
        var formData = _.pick(this.state, ['Comment'])
        console.log('value', _.get(this.state.ActivityType,'value')  );
        console.log(' this.state.currentRecord.ActivityType',  this.state.currentRecord.ActivityType  );
        if (_.get(this.state.ActivityType,'value') !==this.state.currentRecord.ActivityType){
            formData.ActivityType =_.get(this.state.ActivityType,'value')
        }
        if (this.state.TimeTrackingStartTime == '' || !moment(this.state.TimeTrackingStartTime, 'D/M/YYYY').isValid()) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorDateIsNotValid',
            });
            return false;
        }
        if (this.state.TimeTrackingEndTime == '' || !moment(this.state.TimeTrackingEndTime, 'D/M/YYYY').isValid()) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorDateIsNotValid',
            });
            return false;
        }
        if (this.state.TimeTrackingStartTime.isAfter(this.state.TimeTrackingEndTime) || this.state.TimeTrackingStartTime.isSame(this.state.TimeTrackingEndTime)) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Start time can not be after the tracking time end time',
            });
            return false;
        }
        if (this.state.TimeTrackingEndTime.diff(this.state.TimeTrackingStartTime, 'minutes') > 1440) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Time tracking period can not be greater than 24 hours',
            });
            return false;
        }
        if (!this.state.TimeTrackingStartTime.isSame(moment(this.state.currentRecord.StartTime))) {
            formData.StartTime = this.state.TimeTrackingStartTime
        }
        if (!this.state.TimeTrackingEndTime.isSame(moment(this.state.currentRecord.EndTime))) {
            formData.EndTime = this.state.TimeTrackingEndTime
        }

         if (this.state.newDuration !== convertToHoursAndMinutes(moment.duration(this.state.currentRecord.Duration), {format: 'minutes_in_percentage'})) {
            console.log('not equal'   );
             var minutesInPercent = 0+ (this.state.newDuration - Math.floor(this.state.newDuration))
             var durationObject = moment.duration({
                 hours:  Math.floor(this.state.newDuration),
                 minutes: Math.floor(minutesInPercent * 60)
             })



            // var match = this.state.newDuration.match(/^(0[0-9]|1[0-9]|2[0-3]|[0-9]):([0-5][0-9])$/)
            // /* match HH:mm or H:mm , with hours from 0 to 23 */
            // console.log('match', match);
            // if (!_.get(match, 1) || !_.get(match, 2)) {
            //     this.props.displayMessage({
            //         'messageType': 'warning',
            //         'messageCode': 'Please, specify time value in format HH:mm'
            //     });
            //
            // }
            // var durationObject = moment.duration({
            //     hours: _.get(match, 1),
            //     minutes: _.get(match, 2),
            // })
            // console.log('durationObject', durationObject);
            var milliseconds = durationObject.asMilliseconds()
            if (milliseconds > 86400000) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify time that is less than 24 hours'
                });
                return false;
            }
            if (milliseconds < 60000) {
                   this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify time that is more than 1 minute'
                });
                return false;
            }
            var momentStartTime = moment(this.state.currentRecord.StartTime).utc()
            var updatedWorkEndTime = momentStartTime.add(durationObject)
         formData.EndTime = updatedWorkEndTime
        }
        return formData
    }

    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: row});
    }

    deleteRecord() {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/users_data" + '/' + encodeURIComponent(this.state.currentRecord._id),
            messageData: {'#1#': 'Time log'},
            messageCode: 'recordDeleted',
        };
        this.props.makeRequest({id: this.state.currentRecord._id}, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
            console.log('e', err);
        });

    }


    onSelectTab() {
        this.setState({displayReportTab: !this.state.displayReportTab})
    }

    render() {
       // console.log('AdminUserTimeTrackingPage this state', this.state);

        //  console.log('searchbox in', this.refs.searchBox, this.refs.searchBox ? this.refs.searchBox.state.filterOptions.perPage : undefined,);
        return (
            <div >

                <Tabs className="top20" onClick={(event)=>{

                    var queryParams = queryString.parse(this.props.location.search);
                    const stringified = queryString.stringify(_.omit(queryParams, ['recordIDs' ]));
                    this.context.router.push(this.props.location.pathname+'?' + stringified);
                  
                }} defaultActiveKey={this.state.defaultTab} id="timeTracking">
                    <Tab eventKey={'/time-tracking'}  unmountOnExit={true} title="Time tracking list">

                        <div className="top20">
                            {displayTimeTrackingButtons.call(this, {activityType: 'PostingWarehouse'})}

                            { _.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false) !== false &&
                            <div className="text-center" style={{width: 440, margin: '10px auto 10px'}}>
                <span className="text-center top8 " style={{fontSize: 22, verticalAlign: 'middle'}}>
                            <span className="right10">{this.state.currentTimeTracked}</span>
                               <span
                                   className="purple">{_.get(_.find(config.timeTrackingActivityData, {name: _.get(this.props.userReducer.customUserData, 'activityType')}), 'comment', 'activity n/a')}</span>

                        </span>
                            </div>
                            }
                        </div>

                        {config.checkAccessRights.call(this, {resources: ['time_tracking_full']}) &&
                        <AdminUserTimeTrackingActionsBox
                            search={this.search.bind(this)}
                            getVariationOptions={this.getVariationOptions}
                            {...this.props} ></AdminUserTimeTrackingActionsBox>
                        }
                                <AdminUserTimeTrackingSearchBox pending={this.state.pending}
                                                                ref={(searchBox) => {
                                        if (searchBox && !this.searchBox) {
                                            this.searchBox = searchBox;
                                            if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ) { /* by default search only if recordIDs are passed*/
                                                this.search({page:this.state.currentPage+1})
                                            }
                                        }
                                    } }
                                    unmountSearchBox={() => {
                                        this.searchBox = false;
                                    }}
                                    contractorsOptionsList={ this.state.contractorsOptionsList}
                                    selectAllRecords={this.state.selectAllRecords}
                                    onSelectAllRecordsChange={this.onSelectAllRecordsChange.bind(this)}
                                    search={this.search.bind(this)}
                                    {...this.props} ></AdminUserTimeTrackingSearchBox>

                                {this.props.adminUsersData.fetched &&
                                <div>
                                    {this.props.adminUsersData.total == 0 ?
                                        <div
                                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'Data')}</div> :
                                        <div className="top20">
                                            <div className="bot10">Total: <span
                                                className="blue">{this.state.totalDuration}</span></div>
                                            <AdminUserTimeTrackingTable
                                                editRecord={this.editRecord.bind(this)}
                                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                                onSortChange={this.onSortChange.bind(this)}
                                                search={this.search.bind(this)} {...this.props}  ></AdminUserTimeTrackingTable>
                                            <PaginationBox
                                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : _.isUndefined(queryString.parse(this.props.location.search).perPage) ? undefined : queryString.parse(this.props.location.search).perPage}
                                                ref={'pagination'}
                                                total={this.props.adminUsersData.total == 'initial' ? 0 : this.props.adminUsersData.total}
                                                search={this.search.bind(this)}>
                                            </PaginationBox>

                                        </div>}
                                </div>
                                }
                    </Tab>
                    {config.checkAccessRights.call(this, {resources: [ 'time_tracking_edit']}) &&
                    <Tab eventKey={'/time-tracking-registry'} unmountOnExit={true} title="Payout Registry">
                        <ContractorTransactionsPage location={this.props.location}></ContractorTransactionsPage>
                    </Tab>
                    }
                </Tabs>
                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{ 'Edit'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form  >

                            <FormGroup>
                                <ControlLabel>{ 'Start time'}</ControlLabel>
                                <Datetime
                                    //    isValidDate={(date) =>  }
                                    closeOnSelect={true}
                                    dateFormat={'MM-DD-YYYY'} timeFormat={true}
                                    onChange={(value) => this.onDateChange.call(this, value, 'TimeTrackingStartTime')}
                                    inputProps={{
                                        placeholder: 'Start time',

                                    }}
                                    value={this.state.TimeTrackingStartTime}

                                />
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>{ 'End time'}</ControlLabel>
                                <Datetime
                                    closeOnSelect={true}
                                    dateFormat={'MM-DD-YYYY'} timeFormat={true}
                                    onChange={(value) => this.onDateChange.call(this, value, 'TimeTrackingEndTime')}
                                    inputProps={{
                                        placeholder: 'Start time',
                                    }}
                                    value={this.state.TimeTrackingEndTime}

                                />
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>{ 'Duration ' + (this.state.newDuratonInHoursAndMinutes ? this.state.newDuratonInHoursAndMinutes : '')}</ControlLabel>
                                <FormControl
                                    defaultValue={this.state.newDuration}

                                    onChange={(e) =>{
                                        var durationValue =_.trim( e.target.value)
                                        if ( isNaN(durationValue)) {
                                           return this.props.displayMessage({
                                                'messageType': 'warning',
                                                'messageCode': 'Please, specify valid number',
                                            });
                                        }
                                        if (durationValue == '') {
                                            var durationObject = moment.duration({
                                                hours: 0,
                                                minutes: 0
                                            })
                                        }else{
                                          var minutesInPercent = 0+ (durationValue - Math.floor(durationValue))
                                         //   console.log('minutesInPercent', minutesInPercent , Math.floor(minutesInPercent * 60) );
                                            var durationObject = moment.duration({
                                               hours:  Math.floor(durationValue),
                                               minutes: Math.floor(minutesInPercent * 60)
                                            })
                                        }
                                        var milliseconds = durationObject.asMilliseconds()

                                        if (milliseconds > 86400000) {
                                            return this.props.displayMessage({
                                                'messageType': 'warning',
                                                'messageCode': 'Please, specify time that is less than 24 hours'
                                            });

                                        }
                                        if (milliseconds < 60000) {
                                            return this.props.displayMessage({
                                                'messageType': 'warning',
                                                'messageCode': 'Please, specify time that is more than 1 minute'
                                            });

                                        }
                                        this.setState({
                                            newDuratonInHoursAndMinutes:moment.utc(durationObject.as('milliseconds')).format("HH:mm"),
                                            newDuration: _.trim( e.target.value)
                                        })
                                    } }
                                    placeholder="Duration"
                                    type="text"/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>{ 'Activity'}</ControlLabel>
                                <Select
                                    placeholder="Activity"
                                    clearbable={false}
                                    options={_.map(config.timeTrackingActivityData, item=>{
                                        return  {value:item.name,label:item.comment}
                                    })}
                                     onChange={ (option) =>{
                                         this.setState({'ActivityType':option });
                                     }}
                                    value={this.state.ActivityType}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>{ 'Comment'}</ControlLabel>
                                <FormControl
                                    defaultValue={this.state.Comment}
                                    onChange={(e) => this.setState({
                                        Comment: e.target.value
                                    }) }
                                    placeholder="Comment"
                                    type="text"/>
                            </FormGroup>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.deleteRecord() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        allContractorsList: state.allContractorsList,
        userReducer: state.userReducer,
        adminUsersData: state.adminUsersData,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage,getCurrentStoreState}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserTimeTrackingPage);
